import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[codeFormat]',
  standalone: true
})
export class CodeFormatDirective {
  @Input() codeFormat: boolean = false;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (!this.codeFormat) return;

    const inputElement = this.el.nativeElement as HTMLInputElement;
    const originalValue = inputElement.value;

    const formattedValue = originalValue
      .toUpperCase()
      .replace(/[^A-Z0-9_]/g, '');

    if (formattedValue !== originalValue) {
      inputElement.value = formattedValue;
      event.stopPropagation();
      inputElement.dispatchEvent(new Event('input'));
    }
  }
}
